import { MoveFigureGame } from "./MoveFigureGame";

export function Game58() {
    return <MoveFigureGame />
}